import React, { useEffect, useState } from 'react';
import { verifyGeoLocation } from '../../../services/geocomply/geocomply';
import { GEOCOMPLY_REASON } from '../../../services/geocomply/types';
import { translate } from '../../../services/translate';
import { geocomply } from '../../../stores/geocomply';
import { getStoreValue } from '../../../stores/store/utils';
import UiButton from '../../ui/button/UiButton';

export default function GeocomplyRetryGeolocationButton() {
    const [isButtonVisible, setIsButtonVisible] = useState(false);

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            setIsButtonVisible(true);
        }, 2000);

        return () => {
            clearTimeout(timeoutId);
        };
    }, []);

    function retryGeoLocation() {
        const lastReason = getStoreValue(geocomply.lastReason) as GEOCOMPLY_REASON;
        verifyGeoLocation(lastReason)?.catch();
    }

    if (!isButtonVisible) {
        return null;
    }

    return (
        <UiButton onClick={retryGeoLocation} color="default">
            {translate('Retry GeoLocation', 'ui.geocomply')}
        </UiButton>
    );
}
